class Quiz {
    constructor(selector) {
        this.selector = selector;

        this.questions = this.selector.querySelectorAll('[data-step]');
        this.answersContainer = this.selector.querySelectorAll('[data-element="answers"]');
        this.answers = this.selector.querySelectorAll('[data-element="answer"]');
        this.nextButton = this.selector.querySelector('[data-element="next"]');
        this.prevButton = this.selector.querySelector('[data-element="prev"]');
        this.backToStartButton = this.selector.querySelector('[data-element="back_to_start"]');
        this.nextButtonContent = this.nextButton.innerHTML;
        this.loader = this.selector.querySelector('[data-element="loader"]');

        // this.questionCount = selector.getAttribute('data-count');

        this.currentQuestion = 0;
        this.score = 0;
        this.answersArray = {};

        this._nextQuestion = this._nextQuestion.bind(this);
        this._prevQuestion = this._prevQuestion.bind(this);
        this._backToStart = this._backToStart.bind(this);

        this.answersObj = [];
        this.answersContainer.forEach(aC => {
            let aO = new Answers(aC, this.answersArray);
            this.answersObj.push(aO);
        })

        this.nextButton.addEventListener('click', this._nextQuestion);
        this.prevButton.addEventListener('click', this._prevQuestion);
        this.backToStartButton.addEventListener('click', this._backToStart);
    }

    _nextQuestion(event) {
        event.preventDefault();

        this._scrollToTop();

        if (this._checkAnswer()) {
            if (this.currentQuestion === 0) {
                if (this.answersArray['sex'] !== 'F') {
                    this.currentQuestion = 3;
                } else {
                    this.currentQuestion++;
                }
            } else if (this.currentQuestion === 1) {
                if (this.answersArray['pregnant'] !== 'yes') {
                    this.currentQuestion = 3;
                } else {
                    this.currentQuestion++;
                }
            } else {
                this.currentQuestion++;
            }

            if (this.currentQuestion === this.questions.length) {
                this.loader.style.display = 'flex';
                this._showLastStep();
                this.currentQuestion = (this.questions.length - 1);
            } else if (this.answersArray['sex'] === 'F' && this.answersArray['pregnant'] === 'yes' && this.currentQuestion === 5) {
                this.loader.style.display = 'flex';
                this._showLastStep();
                this.currentQuestion = (this.questions.length - 1);
            } else {
                this._generateQuestion();
            }
        }
    }

    _prevQuestion(event) {
        event.preventDefault();

        if (this.currentQuestion === 3) {
            if (this.answersArray['sex'] === 'M') {
                this.currentQuestion = 0;
            } else {
                if (this.answersArray['pregnant'] === 'yes') {
                    this.currentQuestion--;
                } else {
                    this.currentQuestion = 1;
                }
            }
        } else {
            this.currentQuestion--;
        }

        if (this.currentQuestion < 0) {
            this.currentQuestion = 0;
        }

        this._generateQuestion();
    }

    _backToStart(event) {
        event.preventDefault();

        this._scrollToTop();

        const resultTitle = this.selector.querySelector('.calculator__results');
        const noResultText = this.selector.querySelector('.no-result-text');
        const button = this.selector.querySelector('.calculator-button');
        const dietList = this.selector.querySelector('.diet-list');
        const resultsBottomText = this.selector.querySelector('[data-results-bottom-text]');

        if (resultTitle !== null) {
            resultTitle.remove();
        }
        if (resultsBottomText !== null) {
            resultsBottomText.remove();
        }
        if (noResultText !== null) {
            noResultText.remove();
        }
        if (button !== null) {
            button.remove();
        }
        if (dietList !== null) {
            dietList.remove();
        }

        this.currentQuestion = 0;
        this.prevButton.style.display = 'block';
        this.nextButton.style.display = 'block';
        this.answersArray = {};

        this.answersObj.forEach(aO => {
            aO.clearAnswers(this.answersArray);
        })

        this.score = 0;
        this.nextButton.innerHTML = this.nextButtonContent;
        this._generateQuestion();
    }

    _scrollToTop() {
        const isMobile = window.innerWidth <= 768;
        const yOffset = isMobile ? -220 : -320;
        const y = this.selector.getBoundingClientRect().top + window.scrollY + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
    }

    _generateQuestion() {
        console.log(this.answersArray);
        if (this.backToStartButton.style.display !== 'none') {
            this.backToStartButton.style.display = 'none';
        }

        this.questions.forEach(qs => {
            let step = parseInt(qs.getAttribute('data-step'));
            if (this.currentQuestion === step) {
                qs.classList.add('active');
            } else {
                qs.classList.remove('active');
            }
        });

        if (this.currentQuestion === 6) {
            let lose = this.selector.querySelector('[data-value="lose"]');
            let gain = this.selector.querySelector('[data-value="gain"]');

            lose.style.display = 'block';
            gain.style.display = 'block';
            this._calculateScore();
            if (this.score < 1000) {
                lose.style.display = 'none';
            } else if (this.score > 3900) {
                gain.style.display = 'none';
            }
        }

        if (this.currentQuestion === 0) {
            this.prevButton.style.display = 'none';
        } else {
            this.prevButton.style.removeProperty("display");
        }
        if ((this.currentQuestion === (this.questions.length - 1)) || (this.answersArray['sex'] === 'F' && this.answersArray['pregnant'] === 'yes' && this.currentQuestion === 4)) {
            this.nextButton.innerHTML = 'Zobacz diety';
        } else {
            this.nextButton.innerHTML = this.nextButtonContent;
        }
    }

    _checkAnswer() {
        if (Object.keys(this.answersArray).length > 0 && this.currentQuestion === 3) {
            Object.entries(this.answersArray).forEach(([key, value]) => {
                if (value.trim() === '') {
                    delete this.answersArray[key];
                }
            });
        }

        if (this.currentQuestion === 3) {
            let checkedAnswer = [];
            this.questions[this.currentQuestion].querySelectorAll('[data-element="answer"]').forEach(q => {
                let value = q.getAttribute('data-name');
                checkedAnswer.push(value);
                if (isNaN(Number(this.answersArray[value])) || this.answersArray[value].trim() === '') {
                    this._handleError("Wprowadź prawidłową wartość")
                }
            });
            return checkedAnswer.every(key => key in this.answersArray);
        } else {
            let checkedAnswer = this.questions[this.currentQuestion].querySelector('[data-element="answer"]').getAttribute('data-name');
            if (!this.answersArray.hasOwnProperty(checkedAnswer)) {
                this._handleError('Zaznacz odpowiedź');
            }
            return this.answersArray.hasOwnProperty(checkedAnswer);
        }
    }

    _showLastStep() {
        let score = 0;
        score = this._calculateScore();
        this.backToStartButton.style.display = 'block';
        console.log(score);
        console.log(this.score);
        this.questions.forEach(q => {
            q.classList.remove('active');
        });
        this.prevButton.style.display = 'none';
        this.nextButton.style.display = 'none';

        if (score === 0) {
            this._showNoResults();
            this.loader.style.display = 'none';
        } else {

            this._getPosts().then(data => {
                this.loader.style.display = 'none';
                if (data.length > 0) {
                    this._showResultTitle(true);

                    const list = document.createElement('div');
                    list.classList.add('diet-list');

                    this.selector.appendChild(list);

                    data.forEach(diet => {
                        const post = document.createElement('div');
                        let dietTitle = document.createElement('a');
                        let dietLead = document.createElement('div');
                        let dietName = document.createElement('h3');

                        let dietImage = document.createElement('a');
                        let dietImg = document.createElement('img');

                        let dietButton = document.createElement('a');

                        post.classList.add('diet', 'diet--list');

                        dietTitle.classList.add('diet__title');
                        dietTitle.setAttribute('href', `${diet.link}`);
                        dietTitle.setAttribute('target', '_blank');

                        dietLead.classList.add('diet__lead');
                        dietLead.innerHTML = `${diet.description}`;
                        dietName.classList.add('title', 'title--normal', 'title--24');
                        dietName.innerHTML = `${diet.title}`;

                        dietImage.classList.add('diet__image');
                        dietImage.setAttribute('href', `${diet.link}`);
                        dietImage.setAttribute('target', '_blank');

                        dietImg.classList.add('diet__img', 'wp-post-image');
                        dietImg.setAttribute('src', `${diet.image}`);

                        dietButton.classList.add('button', 'button--cta', 'diet_button');
                        dietButton.innerHTML = 'Zamów<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                            '        <path d="M9.59152 0.532569C10.6032 0.140575 11.8456 0.27124 12.7674 0.872648C13.9054 1.61522 14.1212 2.91487 13.9461 4.26702C13.5007 7.70747 11.3633 10.3966 9.05569 12.608C8.59106 13.0536 7.93854 13.8085 7.31065 13.98C6.7684 14.1281 5.95904 13.4165 5.53187 13.0869C4.31516 12.1477 3.28365 10.9233 2.38918 9.6307C0.867351 7.43098 -0.854144 4.14685 0.476589 1.36731C1.1639 -0.0670892 2.53478 -0.221087 3.84089 0.214657C5.12987 0.644568 6.56499 3.10037 6.94344 3.15753C7.18806 3.19487 8.35339 1.01148 9.59152 0.532569Z"\n' +
                            '              fill="white"/>\n' +
                            '    </svg>';
                        dietButton.setAttribute('href', `${diet.link}`);
                        dietButton.setAttribute('target', '_blank');

                        list.appendChild(post);

                        post.appendChild(dietTitle);
                        dietTitle.appendChild(dietLead);
                        dietTitle.appendChild(dietName);
                        post.appendChild(dietImage);
                        dietImage.appendChild(dietImg);
                        post.appendChild(dietButton);

                    });


                    let text = document.createElement('p');
                    text.setAttribute('data-results-bottom-text', '');
                    text.classList.add('title', 'title--18', 'title--center');
                    text.style.marginTop = '20px';
                    text.innerHTML = 'Po 1-2 tygodniach stosowania diety warto skonsultować jej efekty z dietetykiem w celu ewentualnej korekty kaloryczności lub doboru innego wariantu Twojej diety. <a href="/darmowa-konsultacja-dietetyczna/" target="_blank">Umów się na rozmowę z dietetykiem LOVE.</a>'
                    this.selector.appendChild(text);

                } else {
                    this.loader.style.display = 'none';
                    this._showNoResults();
                }

            });
        }
    }

    _showNoResults() {
        this._showResultTitle();

        const noResultText = document.createElement('div');
        noResultText.classList.add('no-result-text');
        noResultText.innerHTML = '<h3 class="title title--normal title--24">Niestety nie udało nam się znaleźć diety dopasowanej specjalnie dla Ciebie.</h3><br />' +
            'Kliknij przycisk poniżej i wypełnij formularz abyśmy mogli się skontaktować z Tobą w celu dopasowania diety spersonalizowanej pod Ciebie.';

        const button = document.createElement('a');
        button.setAttribute('href', '/darmowa-konsultacja-dietetyczna/');
        button.classList.add('calculator-button');
        button.innerHTML = 'Darmowa konsultacja dietetyczna';
        button.innerHTML += '<svg width="20" height="13" viewBox="0 0 20 13" fill="none"\n' +
            '                             xmlns="http://www.w3.org/2000/svg">\n' +
            '                            <path fill-rule="evenodd" clip-rule="evenodd"\n' +
            '                                  d="M19.9118 6.18442L19.9643 5.44514L19.9648 5.442L19.963 5.44173L19.9486 5.43951C19.9349 5.43734 19.9128 5.43376 19.8831 5.42863C19.8238 5.41835 19.7341 5.40186 19.6191 5.37791C19.3889 5.32994 19.0591 5.25242 18.6699 5.13566C17.8862 4.90055 16.888 4.5141 15.9795 3.90845C15.1385 3.34782 14.4663 2.40019 13.9918 1.53025C13.7595 1.10444 13.5849 0.716505 13.4688 0.435953C13.4109 0.296032 13.368 0.183772 13.34 0.108029C13.326 0.0701823 13.3158 0.0415301 13.3094 0.0231848L13.3026 0.0035634L13.3014 0C13.3014 0.000139713 13.3015 0.000290871 12.59 0.237462C11.8785 0.474632 11.8785 0.474806 11.8786 0.474991L11.8787 0.475419L11.8791 0.476479L11.8801 0.479414L11.8832 0.4885L11.8938 0.519171C11.9028 0.545028 11.9159 0.581549 11.9329 0.62759C11.9669 0.719622 12.0168 0.849988 12.0828 1.00948C12.2145 1.32775 12.4116 1.76578 12.6749 2.24853C13.1916 3.19572 14.0061 4.39561 15.1474 5.15652C15.294 5.25422 15.4419 5.34677 15.5904 5.43442H0.0352993V6.93442H15.5904C15.4419 7.02207 15.294 7.11462 15.1474 7.21231C14.0061 7.97323 13.1916 9.17311 12.6749 10.1203C12.4116 10.6031 12.2145 11.0411 12.0828 11.3594C12.0168 11.5188 11.9669 11.6492 11.9329 11.7412C11.9159 11.7873 11.9028 11.8238 11.8938 11.8497L11.8832 11.8803L11.8801 11.8894L11.8791 11.8924L11.8787 11.8934L11.8786 11.8938C11.8785 11.894 11.8785 11.8942 12.59 12.1314C13.3015 12.3685 13.3014 12.3687 13.3014 12.3688L13.3026 12.3653L13.3094 12.3456C13.3158 12.3273 13.326 12.2987 13.34 12.2608C13.368 12.1851 13.4109 12.0728 13.4688 11.9329C13.5849 11.6523 13.7595 11.2644 13.9918 10.8386C14.4663 9.96865 15.1385 9.02102 15.9795 8.46039C16.888 7.85473 17.8862 7.46828 18.6699 7.23317C19.0591 7.11641 19.3889 7.03889 19.6191 6.99092C19.7341 6.96697 19.8238 6.95048 19.8831 6.94021C19.9128 6.93507 19.9349 6.9315 19.9486 6.92933L19.963 6.92711L19.9648 6.92684L19.9643 6.9237L19.9118 6.18442Z"\n' +
            '                                  fill="#1C1D1C"/>\n' +
            '                        </svg>';

        this.selector.appendChild(noResultText);
        this.selector.appendChild(button);
    }

    _showResultTitle(diets = false) {
        const resultContainer = document.createElement('div');
        resultContainer.classList.add('calculator__results', 'title');
        resultContainer.innerHTML = this._getResultMessage(diets);
        this.selector.appendChild(resultContainer);
    }

    _getResultMessage(diets) {
        let kcal = 0;
        const dietMapping = {
            "all": "jem wszystko",
            "no-meat": "nie jem mięsa",
            "no-meat-fish": "nie jem mięsa i ryb",
            "no-fish": "nie jem ryb",
            "no-gluten": "nie jem glutenu",
            "no-lactose": "nie jem laktozy",
            "no-gluten-lactose": "nie jem glutenu i laktozy",
            "no-dairy": "nie jem nabiału i glutenu",
            "low-carbs": "ograniczam węglowodany",
            "low-meat": "ograniczam mięso",
            "cleanse": "chcę oczyścić organizm"
        };

        if (this.answersArray['sex'] === 'F' && (this.answersArray.hasOwnProperty('pregnant') && this.answersArray['pregnant'] === 'yes')) {
            if (this.answersArray.hasOwnProperty('trimester')) {
                if (this.score < 1400) {
                    return 'Skonsultuj się z dietetykiem';
                }
                if (this.answersArray['trimester'] === '1') {
                    if (this.score < 1600) {
                        kcal = '1500';
                    } else if (this.score < 1900) {
                        kcal = '1800';
                    } else if (this.score < 2200) {
                        kcal = '2000';
                    } else if (this.score < 2400) {
                        kcal = '2200';
                    } else {
                        return 'Skonsultuj się z dietetykiem';
                    }
                } else if (this.answersArray['trimester'] === '2') {
                    if (this.score < 1600) {
                        kcal = '1800';
                    } else if (this.score < 1900) {
                        kcal = '2000';
                    } else if (this.score < 2200) {
                        kcal = '2200';
                    } else if (this.score < 2400) {
                        kcal = '2500';
                    } else {
                        return 'Skonsultuj się z dietetykiem';
                    }
                } else if (this.answersArray['trimester'] === '3') {
                    if (this.score < 1600) {
                        kcal = '2000';
                    } else if (this.score < 1900) {
                        kcal = '2200';
                    } else if (this.score < 2200) {
                        kcal = '2500';
                    } else {
                        return 'Skonsultuj się z dietetykiem';
                    }
                }
            }
        } else if (this.answersArray['sex'] === 'F' && (this.answersArray.hasOwnProperty('pregnant') && this.answersArray['pregnant'] === 'lactation')) {
            if (this.score < 1400) {
                return 'Skonsultuj się z dietetykiem';
            } else if (this.score < 1600) {
                kcal = '2000';
            } else if (this.score < 1900) {
                kcal = '2200';
            } else if (this.score < 2200) {
                kcal = '2500';
            } else {
                return 'Skonsultuj się z dietetykiem';
            }
        } else {
            if (this.score < 1000) {
                return 'Skonsultuj się z dietetykiem';
            } else if (this.score < 1200) {
                if (this.answersArray['goal'] === 'lose' || this.answersArray['goal'] === 'keep') {
                    kcal = '1000';
                } else if (this.answersArray['goal'] === 'gain') {
                    kcal = '1300-1500';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score < 1400) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '1000';
                } else if (this.answersArray['goal'] === 'keep') {
                    kcal = '1200-1300';
                } else if (this.answersArray['goal'] === 'gain') {
                    kcal = '1500';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score < 1600) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '1200';
                } else if (this.answersArray['goal'] === 'keep') {
                    kcal = '1500';
                } else if (this.answersArray['goal'] === 'gain') {
                    kcal = '1700-1800';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score < 1900) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '1500';
                } else if (this.answersArray['goal'] === 'keep') {
                    kcal = '1700-1800';
                } else if (this.answersArray['goal'] === 'gain') {
                    kcal = '2000-2100';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score < 2200) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '1700-1800';
                } else if (this.answersArray['goal'] === 'keep') {
                    kcal = '2000-2100';
                } else if (this.answersArray['goal'] === 'gain') {
                    kcal = '2200';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score < 2400) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '2000-2100';
                } else if (this.answersArray['goal'] === 'keep') {
                    kcal = '2200';
                } else if (this.answersArray['goal'] === 'gain') {
                    kcal = '2500';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score < 2700) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '2200';
                } else if (this.answersArray['goal'] === 'keep') {
                    kcal = '2500';
                } else if (this.answersArray['goal'] === 'gain') {
                    kcal = '3000';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score < 3200) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '2500';
                } else if (this.answersArray['goal'] === 'keep') {
                    kcal = '3000';
                } else if (this.answersArray['goal'] === 'gain') {
                    kcal = '3500';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score < 3700) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '3000';
                } else if (this.answersArray['goal'] === 'keep') {
                    kcal = '3500';
                } else if (this.answersArray['goal'] === 'gain') {
                    return 'Skonsultuj się z dietetykiem';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else if (this.score <= 3900) {
                if (this.answersArray['goal'] === 'lose') {
                    kcal = '3500';
                } else if (this.answersArray['goal'] === 'keep' || this.answersArray['goal'] === 'gain') {
                    return 'Skonsultuj się z dietetykiem';
                } else {
                    return 'Skonsultuj się z dietetykiem';
                }
            } else {
                return 'Skonsultuj się z dietetykiem';
            }
        }

        let choose = 'Wybrałeś';
        if (this.answersArray['sex'] === 'F') {
            choose = 'Wybrałaś';
        }

        let message = `Twoje zapotrzebowanie kaloryczne wynosi około ${kcal} kcal. `;

        if (this.answersArray['sex'] !== 'F' || (this.answersArray['sex'] === 'F' && this.answersArray.hasOwnProperty('pregnant') && this.answersArray['pregnant'] === 'no')) {
            message += `${choose} wariant ${dietMapping[this.answersArray['diet']]}`;
            if (diets) {
                message += ', dlatego proponujemy Ci następujące opcje:';
            } else {
                message += '.';
            }
        } else {
            if (diets) {
                message += 'Proponujemy ci następujące opcje:';
            }
        }

        return message;
    }

    _calculateScore() {
        if (this.answersArray.hasOwnProperty('pregnant')) {
            if (this.answersArray.hasOwnProperty('trimester')) {
                if (this.answersArray['pregnant'] !== 'yes') {
                    delete this.answersArray['trimester'];
                }
            }
            if (this.answersArray['sex'] === 'M') {
                delete this.answersArray['pregnant'];
                delete this.answersArray['trimester'];
            }
        }

        let pal = 1;
        let goal = 0;
        let score = 0;

        if ((this.answersArray['work'] === 'desk' && this.answersArray['activity'] === 'none') || (this.answersArray['work'] === 'mixed' && this.answersArray['activity'] === 'none')) {
            pal = 1.2;
        } else if ((this.answersArray['work'] === 'desk' && this.answersArray['activity'] === 'low') || (this.answersArray['work'] === 'mixed' && this.answersArray['activity'] === 'low') || (this.answersArray['work'] === 'desk' && this.answersArray['activity'] === 'medium')) {
            pal = 1.4;
        } else if ((this.answersArray['work'] === 'mixed' && this.answersArray['activity'] === 'medium') || (this.answersArray['work'] === 'manual' && this.answersArray['activity'] === 'none') || (this.answersArray['work'] === 'desk' && this.answersArray['activity'] === 'high')) {
            pal = 1.6;
        } else if ((this.answersArray['work'] === 'manual' && this.answersArray['activity'] === 'low') || (this.answersArray['work'] === 'manual' && this.answersArray['activity'] === 'medium') || (this.answersArray['work'] === 'desk' && this.answersArray['activity'] === 'very-high') || (this.answersArray['work'] === 'mixed' && this.answersArray['activity'] === 'high') || (this.answersArray['work'] === 'mixed' && this.answersArray['activity'] === 'very-high')) {
            pal = 1.8
        } else if ((this.answersArray['work'] === 'manual' && this.answersArray['activity'] === 'high') || (this.answersArray['work'] === 'manual' && this.answersArray['activity'] === 'very-high')) {
            pal = 2;
        }

        // if (this.answersArray['goal'] === 'lose') {
        //     goal = -300;
        // } else if (this.answersArray['goal'] === 'gain') {
        //     goal = 300;
        // }

        if (this.answersArray['sex'] === 'F') {
            this.score = ((655.1 + (9.563 * this.answersArray['weight']) + (1.85 * this.answersArray['height']) - (4.676 * this.answersArray['age'])) * pal) + goal;
        } else {
            this.score = ((66.473 + (13.752 * this.answersArray['weight']) + (5.003 * this.answersArray['height']) - (6.775 * this.answersArray['age'])) * pal) + goal;
        }

        if (this.answersArray['sex'] === 'F' && (this.answersArray['pregnant'] === 'yes' || this.answersArray['pregnant'] === 'lactation')) {
            if (this.score >= 1400) {
                if (this.score < 1600) {
                    score = 14;
                } else if (this.score < 1900) {
                    score = 16;
                } else if (this.score < 2200) {
                    score = 19;
                } else if (this.score < 2400) {
                    score = 22;
                }
            }
        } else {
            if (this.score > 999) {
                if (this.score < 1200) {
                    score = 10;
                } else if (this.score < 1400) {
                    score = 12;
                } else if (this.score < 1600) {
                    score = 14;
                } else if (this.score < 1900) {
                    score = 16;
                } else if (this.score < 2200) {
                    score = 19;
                } else if (this.score < 2400) {
                    score = 22;
                } else if (this.score < 2700) {
                    score = 24;
                } else if (this.score < 3200) {
                    score = 27;
                } else if (this.score < 3700) {
                    score = 32;
                } else if (this.score <= 3900) {
                    score = 37;
                }
            }
        }

        this.answersArray.score = score;
        this.answersArray.fullScore = this.score;

        return score;
    }

    _handleError(error) {
        const modal = this.selector.querySelector('[data-element="error-modal"]');
        const close = this.selector.querySelector('[data-element="error-close"]');
        const message = this.selector.querySelector('[data-element="error-message"]');

        modal.style.display = 'block';
        message.innerHTML = error;

        const closeHandler = () => {
            modal.style.display = 'none';
            document.removeEventListener('click', outsideClickListener);
        };

        close.addEventListener('click', closeHandler, {once: true});

        const outsideClickListener = (event) => {
            if (!modal.contains(event.target)) {
                modal.style.display = 'none';
                document.removeEventListener('click', outsideClickListener);
            }
        };

        setTimeout(() => {
            document.addEventListener('click', outsideClickListener);
        }, 500);
    }

    _getPosts() {
        // return fetch('/wp-content/themes/lovecatering/dist/diets.json', {
        return fetch('/wp-json/netivo/v1/diet-search', {
            method: 'POST',
            cache: 'no-cache',
            credentials: "same-origin",
            redirect: "follow",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.answersArray)
        }).then(response => {
            if (!response.ok) {
                return response.json().then(function (response) {
                    throw Error(response.code);
                })
            } else {
                return response.json();
            }
        });
    }

}

class Answers {
    constructor(selector, all_answers) {
        this.selector = selector;
        this.ans = all_answers;
        this.type = this.selector.getAttribute('data-type');

        this._clickAnswer = this._clickAnswer.bind(this);
        this._changeAnswer = this._changeAnswer.bind(this);

        this.answers = this.selector.querySelectorAll('[data-element="answer"]');
        this.answers.forEach(a => {
            if (this.type !== 'text') {
                a.addEventListener('click', this._clickAnswer);
            } else {
                a.addEventListener('change', this._changeAnswer)
            }
        })
    }

    _clickAnswer(event) {
        event.preventDefault();

        let name = event.target.getAttribute('data-name');
        let value = event.target.getAttribute('data-value');

        if (this.type === 'multiple') {

            if (!this.ans.hasOwnProperty(name)) {
                this.ans[name] = [];
            }

            if (event.target.classList.contains('active')) {
                event.target.classList.remove('active');
                let index = this.ans[name].indexOf(value);

                if (index !== -1) {
                    this.ans[name].splice(index, 1);
                }
            } else {
                this.ans[name].push(value);
                event.target.classList.add('active');
            }
        } else {
            this.ans[name] = value;

            this.answers.forEach(a => {
                a.classList.remove('active');
            });
            event.target.classList.add('active');
        }

    }

    _changeAnswer(event) {
        let name = event.target.getAttribute('data-name');

        if (!this.ans.hasOwnProperty(name)) {
            this.ans[name] = [];
        }
        this.ans[name] = event.target.value;
    }

    clearAnswers(answerArray) {
        this.ans = answerArray;
        this.answers.forEach(a => {
            if (this.type !== 'text') {
                a.classList.remove('active');
            } else {
                a.value = '';
            }
        })
    }
}


export default Quiz;